module.exports = "<button md-effect type=\"button\" class=\"btn btn-info btn-sm mt-1\"\n  uib-tooltip=\"Paralizar Proyecto\" ng-click=\"$ctrl.verMensaje()\">\n  <i class=\"fa fa-ban\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/proyectos/bandeja/paralizar/button.html
// module id = 643
// module chunks = 0